import { render } from "./AddCategory.vue?vue&type=template&id=feb57fe0&scoped=true&ts=true"
import script from "./AddCategory.vue?vue&type=script&lang=ts"
export * from "./AddCategory.vue?vue&type=script&lang=ts"

import "./AddCategory.vue?vue&type=style&index=0&id=feb57fe0&lang=scss&scoped=true"

import exportComponent from "D:\\YellowBeardProject\\keisi\\keisishopadmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-feb57fe0"]])

export default __exports__